import styleText from './as-panel.css?raw';

export class AsPanel extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    this.shadowRoot.innerHTML = /*html*/`
      <slot></slot>
    `

    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsPanel.sheet
    ];
  }
}

// Check if the element is already defined before registering it
if (!customElements.get('as-panel')) {
  customElements.define('as-panel', AsPanel);
} else {
  console.warn("as-panel already defined");
} 
